var helper = {

    /*
     * usage :
     * return DOM element
     */
    context: (name) => {
        try {
            return document.querySelector(`[${name}]`);
        } catch (e) {
            console.log(e, name);
        }

        return null;
    },

    /*
     * usage :
     * return -
     */
    event: (element, events, listener, params = null) => {
        if (element !== null) {
            var event = events.split(' ');
            for (let i = 0, iLen = event.length; i < iLen; i++) {
                element.addEventListener(event[i], listener, false);
                if (params !== null) {
                    element.addEventListener(event[i], listener, params);
                }
            }
        }
    },

    /*
     * usage :
     * return DOM element
     */
    element: (name, all = false) => {
        try {
            let elm = null;
            if (name.substring(0,1) === ".") {
                elm = document.getElementsByClassName(name.substring(1));
            } else if (name.substring(0,1) === "#") {
                elm = document.getElementById(name.substring(1));
            } else {
                elm = document.getElementsByTagName(name);
                if (elm.length === 0) {
                    elm = document.querySelector(name);
                }
            }
            if (elm && elm.length > 0) {
                return all ? elm : elm[0];
            } else {
                return elm;
            }
        } catch (e) {
            // error.. ignore..
        }

        return null;
    },

    /*
     * usage :
     * return true/false
     */
    validate: (fields, checkall = false) => {
        let success = true;
        Object.values(fields).forEach(function(item, k) {
            if (item.classList.contains("js-required") || item.classList.contains("js-validate")) {
                let pattern = new RegExp(item.getAttribute("pattern"));
                if (((item.value.trim() === "" && item.classList.contains("js-required")) || (item.getAttribute("pattern") !== null) ? !pattern.test(item.value.trim()) : false) && item.getAttribute("type") !== "radio" && item.getAttribute("type") !== "checkbox") {
                    if ((item.value.trim() === "" && item.classList.contains("js-required")) || (item.value.trim() !== "" && item.classList.contains("js-validate"))) {
                        success = false;
                    }
                    if (item.classList.contains("validated") || checkall) {
                        item.classList.add("error");
                        item.classList.remove("valid");
                    }
                    if (item.value.trim() === "" && item.classList.contains("js-validate")) {
                        item.classList.remove("error");
                        item.classList.add("valid");
                    }
                } else {
                    item.classList.remove("error");
                    item.classList.add("valid");
                }

                if (checkall) {
                    if (item.getAttribute("type") === "radio" || item.getAttribute("type") === "checkbox") {
                        const c = document.querySelector(`input[name="${item.name}"]:checked`);
                        const group = helper.element(`.js-group-${item.name}`, false);
                        if (group) {
                            if (c !== null) {
                                group.classList.remove("error");
                                group.classList.add("valid");
                            } else {
                                success = false;
                                group.classList.add("error");
                                group.classList.remove("valid");
                            }
                        }
                    }
                }
            }
        });

        return success;
    },

    /*
     * usage :
     * delay(0.5).then(function() {   });
     *
     * return -
     */
    delay: (duration) => {
        return new Promise(resolve => setTimeout(resolve, duration));
    }
};
